export const SET_PLAYGROUND_EXPERIMENT_RECORDING_TOOL_NAME =
  "set_playground_experiment_recording";
